import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import DepositPayment from './DepositPayment';

export default function PaymentDeposits() {
  return (
    <CasinoContainer title={'Deposit limits'}>
      <DepositPayment />
    </CasinoContainer>
  );
}
